import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IChatBotResponse, IChatDataInput } from '../../../interface/interfaces';

interface IInitalState {
    chatResponseLoading: boolean;
    chatResponseData: IChatBotResponse;
    chatBotResponseError: string;
}

const initialChatResponseData = {
    response: '',
    chat_history: [],
};

const initialState: IInitalState = {
    chatResponseLoading: false,
    chatResponseData: initialChatResponseData,
    chatBotResponseError: '',
};

const chatBotResponseSlice = createSlice({
    name: 'chatBotResponse',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchChatBotResponsePading: (state: IInitalState, action: PayloadAction<IChatDataInput>) => {
            (state.chatResponseLoading = true), (state.chatBotResponseError = '');
        },
        fetchChatBotResponseFulfilled: (state: IInitalState, action: PayloadAction<IChatBotResponse>) => {
            (state.chatResponseLoading = false), (state.chatResponseData = action.payload), (state.chatBotResponseError = '');
        },
        fetchChatBotResponseFailure: (state: IInitalState, action: PayloadAction<string>) => {
            (state.chatResponseLoading = false), (state.chatResponseData = initialChatResponseData), (state.chatBotResponseError = action.payload);
        },
    },
});

export default chatBotResponseSlice.reducer;
export const { fetchChatBotResponsePading, fetchChatBotResponseFulfilled, fetchChatBotResponseFailure } = chatBotResponseSlice.actions;
